import { useEffect } from 'react';

export function useDocumentTitle(title: string | undefined | null) {
    useEffect(() => {
        if(title) {
            document.title = `${title} | Dajeh`
        }
    }, [title]);
}
